<template>
    <div class="header">
      <div class="header__wrap main-container">
        <span>
            <div class="back-to-home" @click="backToHome">
            <i class="bi bi-chevron-left"></i> {{ getTranslatedText("live number draws") }}
            </div>
          <h3>{{ getTranslatedText(this.$route.name) }}</h3>
        </span>
        <div class="header__right">
          <h2>&nbsp;</h2>
          <BalanceDisplay />
        </div>
      </div>
    </div>
  </template>
  
  <script>
  import languageMixins from "@/mixins/language-mixins";
  import BalanceDisplay from "@/components/common/BalanceDisplay.vue";
  
  export default {
    name: 'OtherHeaderComponent',
    mixins: [languageMixins],
    components: {
      BalanceDisplay,
    },
    methods: {
        backToHome() {
        const query = this.$route.query;
        this.$router.push({ path: "/", query });
        this.$store.commit("setMarketSelected", null);
      }
    }
  };
  </script>
  
  <style lang="scss">
  @import "@/public/scss/header/_index.scss";
  .header__wrap {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 40px !important;
  }
  .back-to-home {
    display: flex;
    align-items: center;
    cursor: pointer;
    font-size: 12px;
    color: #fff;
    margin-bottom: 10px;
  }
  .header__right {
    align-items: center;
    color: #fff;
    font-size: 14px;
  }

  @media (max-width: 768px) { 
    .header__wrap {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 20px !important;
  }
  }
  </style>
  